export default __webpack_public_path__ + "static/aikido-bane-095c9c14b41cfb91a8bf83cc1ef72dd4.jpg";